import {FormControl, FormGroup} from '@angular/forms';
import {FormValue, Translation} from '@brunata-angular/util';
import {SelectableItem} from '@brunata-angular/ui';

export type EditAgentEvent = {
    reportId: string;
    agentName: string;
};

export type ConsumptionAgentOverviewTableFilterFormGroup = FormGroup<{
    meterCriteriaMismatch: FormControl<SelectableItem[]>;
    agentName: FormControl<string>;
    investigation: FormControl<string>;
    meterSuperTypeNo: FormControl<SelectableItem[]>;
    usageAndUnit: FormControl<string>;
    dayCount: FormControl<string>;
    consumptionToMonitor: FormControl<SelectableItem[]>;
    agentType: FormControl<string>;
    schedule: FormControl<SelectableItem[]>;
    recipients: FormControl<string>;
    sendBlank: FormControl<SelectableItem[]>;
    showConsumptionForMeters: FormControl<SelectableItem[]>;
}>;

export type ConsumptionAgentOverview = {
    reportId: string;
    agentName: string;
    investigation: string;
    meterSuperTypeNo: string;
    usageAndUnit: string;
    consumptionToMonitor: string;
    agentType: string;
    schedule: string;
    recipients: string;
    dayCount: number;
    meterCriteriaMismatch: boolean;
    sendBlank: boolean;
    showConsumptionForMeters: boolean;
};

export type ConsumptionAgentTableColumnHeader = {
    label: Translation;
    column: keyof FormValue<ConsumptionAgentOverviewTableFilterFormGroup>;
    formType: 'text' | 'selectMultiple';
};

export const CONSUMPTION_AGENT_TABLE_HEADERS: ConsumptionAgentTableColumnHeader[] = [
    {
        label: {
            key: 'common_configuration-status',
        },
        column: 'meterCriteriaMismatch',
        formType: 'selectMultiple',
    },
    {
        label: {
            key: 'monitoring_agentName',
        },
        column: 'agentName',
        formType: 'text',
    },
    {
        label: {
            key: 'monitoring_meterType',
        },
        column: 'meterSuperTypeNo',
        formType: 'selectMultiple',
    },
    {
        label: {
            key: 'monitoring_usageAndUnits',
        },
        column: 'usageAndUnit',
        formType: 'text',
    },
    {
        label: {
            key: 'label_days',
            application: 'online',
            module: 'common',
        },
        column: 'dayCount',
        formType: 'text',
    },
    {
        label: {
            key: 'monitoring_consumptionType',
        },
        column: 'consumptionToMonitor',
        formType: 'selectMultiple',
    },
    {
        label: {
            key: 'monitoring_investigation',
        },
        column: 'agentType',
        formType: 'text',
    },
    {
        label: {
            key: 'monitoring_schedule',
        },
        column: 'schedule',
        formType: 'selectMultiple',
    },
    {
        label: {
            key: 'monitoring_recipients',
        },
        column: 'recipients',
        formType: 'text',
    },
    {
        label: {
            key: 'monitoring_sendBlanks',
        },
        column: 'sendBlank',
        formType: 'selectMultiple',
    },
    {
        label: {
            key: 'monitoring_show-consumption-for-individual-meters',
        },
        column: 'showConsumptionForMeters',
        formType: 'selectMultiple',
    },
];

export const SCHEDULE_SORT_ORDER = [
    {
        name: 'DISABLED',
        sortOrder: 1,
    },
    {
        name: 'HOURLY',
        sortOrder: 2,
    },
    {
        name: 'DAILY_8AM',
        sortOrder: 3,
    },
    {
        name: 'WEEKLY_EVERY_MONDAY_8AM',
        sortOrder: 4,
    },
    {
        name: 'BIMONTHLY_EVERY_SECOND_MONDAY_8AM',
        sortOrder: 5,
    },
    {
        name: 'MONTHLY_FIRST_8AM',
        sortOrder: 6,
    },
];
